(function () {
  'use strict';
  if (window.svemobQualityReady) return;
  window.svemobQualityReady = true;
  var summaries = {
    prime: 'In-Cell-skärm i FDX:s standardserie. Ett alternativ inom LCD-segmentet.',
    elite: 'FDX:s premiumserie inom In-Cell. Ett mer påkostat LCD-alternativ.',
    lite: 'In-Cell-skärm i FDX:s budgetserie med HD-upplösning.',
    pro: 'FDX:s serie med Hard OLED. Panelen har en styv glasbas.',
    ultra: 'FDX:s serie med Soft OLED. Panelen har en flexibel bas. Finns i olika panelvarianter.',
    refurbished: 'Renoverad skärm med originalpanel från en tidigare använd telefon och utbytt frontglas.',
    pulled: 'Originaldel som har tagits ur en tidigare använd telefon och testats. A, när det anges, är leverantörens skickklass.',
    'service-pack': 'Originaldel tillverkad av telefonens ursprungliga tillverkare.',
    compatible: 'Kompatibel tredjepartsdel. Beteckningen betyder inte att delen är tillverkad av telefonens ursprungliga tillverkare.',
    technology: 'Här ser du vad den angivna skärmtekniken innebär.'
  };
  var technologies = {
    'In-Cell': 'LCD-teknik med integrerat touchlager och bakgrundsbelysning.',
    'LCD': 'Skärmteknik som använder bakgrundsbelysning för att skapa bilden.',
    'Hard OLED': 'OLED med styv glasbas. Varje pixel ger eget ljus.',
    'Soft OLED': 'OLED med flexibel bas. Varje pixel ger eget ljus. Skärmens frontglas är fortfarande ömtåligt.',
    'OLED': 'Varje pixel ger eget ljus, vilket möjliggör djup svärta och hög kontrast.'
  };
  var panelNotes = {
    LTPO: 'Panelteknik som möjliggör mer flexibel anpassning av uppdateringsfrekvensen.',
    LTPS: 'Teknik för panelens styrning. LTPS är inte en kvalitetsklass.'
  };
  var trigger = null;
  var previousOverflow = '';
  function close(dialog) { dialog.close(); }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sv-quality]');
    var dialog = document.getElementById('SvemobQualityDialog');
    if (!dialog) return;
    if (event.target.closest('[data-sv-quality-close]')) { close(dialog); return; }
    if (event.target === dialog) {
      var bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close(dialog);
      return;
    }
    if (!button) return;
    event.preventDefault();
    var data = button.dataset;
    dialog.querySelector('#SvemobQualityTitle').textContent = data.svQualityLabel;
    dialog.querySelector('[data-sv-quality-summary]').textContent = summaries[data.svQuality] || summaries.technology;
    var facts = dialog.querySelector('[data-sv-quality-facts]');
    facts.replaceChildren();
    function row(label, text) {
      var group = document.createElement('div');
      var term = document.createElement('dt');
      var definition = document.createElement('dd');
      term.textContent = label;
      definition.textContent = text;
      group.append(term, definition);
      facts.appendChild(group);
    }
    if (data.svTechnology && technologies[data.svTechnology]) row(data.svTechnology, technologies[data.svTechnology]);
    if (data.svRate) row(data.svRate, 'Anger uppdateringsfrekvensen, alltså hur ofta bilden kan uppdateras. Hz anger inte upplösningen eller kvalitetsklassen.');
    if (data.svPanel && panelNotes[data.svPanel]) row(data.svPanel, panelNotes[data.svPanel]);
    trigger = button;
    if (!dialog.open) {
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    }
  });
  document.addEventListener('close', function (event) {
    if (event.target.id !== 'SvemobQualityDialog') return;
    document.body.style.overflow = previousOverflow;
    if (trigger && trigger.isConnected) trigger.focus({preventScroll: true});
  }, true);
})();
